<template>
<div class="main-contain">
<div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item>消息中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  <!-- 导航 -->
  <div class="main01">
    <div class="main-tip">
       <p>短信可用余额</p>
       <p class="money">{{sms_balance}} <span class="btn-span" @click="$router.push({path:'/home/detection',query:{type:'short'}})">充值</span></p>
    </div>
   
 <el-row :gutter="20" class="searchRow" type="flex" align='middle'>
    <el-col :span="3">
      接收账号:
    </el-col>
    <el-col :span="4">
      <el-input v-model="reciverName" clearable placeholder="请输入接收账号"></el-input>
    </el-col>
    <el-col :span="3">
     发送状态：
    </el-col>
    <el-col :span="4">
      <el-select v-model="aduitStatus" placeholder="状态">
        <el-option v-for="(item,index) in satatus_list" :key="index" :label="item" :value="index">
        </el-option>
      </el-select>
    </el-col>
    <el-col :span="3">
      发送时间：
    </el-col>
    <el-col :span="7">
      <el-date-picker v-model="timeinterval" type="daterange" range-separator="至" value-format="yyyy-MM-dd" format="yyyy-MM-dd" clearable start-placeholder="开始日期" end-placeholder="结束日期">
      </el-date-picker>
    </el-col>
    <el-col :span="8">
      <el-button type="primary" @click="handleButton(1)">搜 索</el-button>
      <el-button plain @click="handleButton(2)">重 置</el-button>
      <!--    <el-button type="primary"
                   @click="handleButton(3)">新增模板</el-button> -->
    </el-col>
  </el-row> 
  <div class="table-content">
 <el-table :data="tableList" v-loading="listLoading" border>
      <el-table-column type="index" prop="size" align="center" label="序号" width="100"></el-table-column>
      <el-table-column align="center" label="接收账号" width="200">
        <template slot-scope="scope">
          {{scope.row.receive_type==1?`${scope.row.cellphones_admin}`:`${scope.row.cellphones_users}`}}
        </template>
      </el-table-column>
      <el-table-column prop="content"  :show-overflow-tooltip="true" label="接收内容" align="center"> </el-table-column>
      <el-table-column prop="scene_message" width="140" :show-overflow-tooltip="true" label="分类" align="center"> </el-table-column>
      <el-table-column width="160" :show-overflow-tooltip="true" label="推送方式" align="center">
        <template slot-scope="scope">
            <span v-if="scope.row.send_type==2">短信/</span> 
        </template>
      </el-table-column>
      <el-table-column prop="send_time" width="180" :show-overflow-tooltip="true" label="发送时间" align="center"> </el-table-column>
      <el-table-column  width="160" label="发送状态" align="center">
        <template slot-scope="scope">
          {{scope.row.send_status==0?'发送成功':scope.row.send_status==1?'发送失败':scope.row.send_status==2?'审核通过':'审核未通过'}}
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <PaginaTion v-if="tableList.length>0" :total="total" :pageNum="pageNum" :pageSize="pageSize" @pageChange="pageChange" />
  </div>
</div></div>
</template>

<script>
import PaginaTion from '@/components/pagination/index.vue'
import {
  mapActions
} from "vuex";
export default {
  props: {

  },
  data() {
    return {
      reciverName: '',
      aduitStatus: 0,
      satatus_list: ['全部', '发送中', '发送成功', '发送失败'],
      timeinterval: '',
      tableList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      title: '',
      rowList: {},
sms_balance:0,
      messVisible: false,
      listLoading: false,
    };
  },
  mounted() {
 this.getListLog()
 this.getMessageMoney()
  },
  methods: {

      ...mapActions({
      MessageList: "message/MessageList",
      MessageMoney: "message/MessageMoney",
    }),
    initModel() {
      this.messVisible = false
    },
    handleButton(key, rows) {
      switch (key) {
        case 1:
          this.pageNum = 1
          this.getListLog()
          break;
        case 2:
          this.pageNum = 1
          this.tepAduitStatus = ''
          this.tepStatus = ''
          this.moudleCode = ''
          this.getListLog()
          break;
        case 3:
          this.messVisible = true
          this.title = '模板添加'
          break;
        case 5:
          this.messVisible = true
          this.title = '模板编辑'
          this.rowList = rows
          break;
        case 6:
          this.messVisible = true
          this.title = '详情'
          this.rowList = rows
          break;

        default:
          break;
      }
    },
    pageChange(page) {
      this.pageSize = page._pageSize;
      this.pageNum = page._currentPage;
      this.getListLog()
    },
    getListLog() {
      this.listLoading = true;
      const data = {
       token: this.$store.state.token,
        start_page: this.pageNum,
        page_size: this.pageSize,
        start_time: this.timeinterval[0],
        end_time: this.timeinterval[1],
        cellphones: this.reciverName,
        send_type: 2

      }
      this.MessageList(data).then(res => {
        this.listLoading = false;
        if (res.code == 1) {
          this.tableList = res.data.data
          this.total = parseInt(res.data.total)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getMessageMoney() {
      const data = {
       token: this.$store.state.token,
      }
      this.MessageMoney(data).then(res => {
        if (res.code == 1) {
         this.sms_balance = res.data.sms_balance
        } else {
          this.$message.error(res.msg)
        }
      })
    },

  },
  components: {
    PaginaTion,

  },
};
</script>

<style lang="scss" scoped>
.searchRow {
  font-size: 14px;
  border-bottom: 0;
  //border-top: 1px solid #ccc;
}
.main-tip,.searchRow,.table-content{
padding:10px 20px ;
}
::v-deep .el-col-3 {
  width: 7.5%;
 }

 .money{
  padding: 10px 0;
  font-weight: 600px;
  font-size: 20px;
  .btn-span{
    display: inline-block;
    margin-left: 30px;
    font-size: 14px;
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    background: hsl(201, 79%, 65%);
   border-radius: 4px;
  }
 }
</style>
